import React, { useState } from 'react';
import Header from '../Components/Header';
import BottomNav from '../Components/BottomNav';
import './Styles/Register.css';
import mpesaLogo from '../assets/mepesa.png'; // Make sure this path is correct

// Modal Component
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
        {children}
      </div>
    </div>
  );
};


const RegisterPage: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState<'airtime' | 'mpesa' | null>(null);
  const [phoneNumber, setPhoneNumber] = useState('');

  const openModal = (type: 'airtime' | 'mpesa') => {
    setModalType(type);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setPhoneNumber(''); // Reset phone number on close
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // Allow only numbers and limit to 10 digits
    if (/^\d*$/.test(value) && value.length <= 10) {
      setPhoneNumber(value);
    }
  };

  const handleMpesaSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (phoneNumber.length === 10) {
      alert(`Submitting phone number: ${phoneNumber}`);
      // Here you would typically make an API call
      closeModal();
    } else {
      alert('Please enter a valid 10-digit phone number.');
    }
  };

  // --- NEW FUNCTIONALITY ---
  const isMobileDevice = () => {
    // Simple regex to check for common mobile user agents
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };

  const handleAirtimeClick = () => {
    if (isMobileDevice()) {
      // On mobile, open the messaging app
      window.location.href = 'sms:0000?body=ok';
    } else {
      // On desktop, show the modal as a fallback
      openModal('airtime');
    }
  };
  // --- END NEW FUNCTIONALITY ---

  return (
    <div className="register-page">
      <Header />
      <main className="register-content">
        <div className="register-wrapper">
          <h1 className="register-title">Choose Your Registration Method</h1>
          <p className="register-subtitle">
            Select one of the options below to create your account and start learning.
          </p>

          <div className="choices-container">
            {/* --- Airtime Choice (with updated onClick) --- */}
            <div className="choice-card" onClick={handleAirtimeClick}>
              <div className="choice-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 18h.01"></path><path d="M16 12h.01"></path><path d="M12 12h.01"></path><path d="M8 12h.01"></path><path d="M12 6h.01"></path><path d="M16 6h.01"></path><path d="M8 6h.01"></path><path d="M16 18h.01"></path><path d="M8 18h.01"></path></svg>
              </div>
              <h2 className="choice-title">Register with Airtime</h2>
              <p className="choice-description">The quickest way to get started via SMS.</p>
              <button className="btn ghost choice-btn">Select</button>
            </div>

            {/* --- M-Pesa Choice --- */}
            <div className="choice-card" onClick={() => openModal('mpesa')}>
              <div className="choice-icon">
                <img src={mpesaLogo} alt="M-Pesa Logo" className="mpesa-logo-icon" />
              </div>
              <h2 className="choice-title">Register with M-Pesa</h2>
              <p className="choice-description">Use your M-Pesa account for seamless access.</p>
              <button className="btn ghost choice-btn">Select</button>
            </div>
          </div>
        </div>
      </main>
      <BottomNav />

      {/* --- Modal --- */}
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        {modalType === 'airtime' && (
          <div className="modal-body">
            <h3 className="modal-title">Airtime Registration</h3>
            <p className="modal-text">
              Alternatively, send <strong>ok</strong> to <strong>0000</strong> to use Hamerhua service.
            </p>
          </div>
        )}
        {modalType === 'mpesa' && (
          <div className="modal-body">
            <img src={mpesaLogo} alt="M-Pesa Logo" className="mpesa-logo-modal" />
            <h3 className="modal-title">Register with M-Pesa</h3>
            <p className="modal-text">
              Enter your 10-digit phone number to proceed.
            </p>
            <form className="mpesa-form" onSubmit={handleMpesaSubmit}>
              <div className="form-group">
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  placeholder="e.g. 712345678"
                  value={phoneNumber}
                  onChange={handlePhoneChange}
                  required
                  pattern="\d{10}"
                  title="Please enter exactly 10 digits."
                />
              </div>
              <button type="submit" className="btn primary form-submit-btn">Submit</button>
            </form>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default RegisterPage;